import React from "react";
import ErrorImg from "assets/img/error.png";
import {Link} from "react-router-dom";
function ErrorPage() {
  return (
    <div>
      <div >
        <div >
          <img src={ErrorImg} alt="Page Not Found" />
          <p>Oops! looks like an unexpected error occured :(</p>
          <Link to="/" >Go back to Homepage</Link>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
